<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div [formGroup]="form">
        <div class="row ticket-form">
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Ticket Type <span class="required-field">*</span></label>
              <select class="form-control" formControlName="typeId">
                <option value="" disabled selected hidden>---Select Type---</option>
                <option *ngFor="let x of IDs" [value]="x.ticketTypeId">{{x.name}}</option>
              </select>
              <span class="err" *ngIf="form.get('typeId').invalid && formSubmit">ticket type required</span>

            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Subject <span class="required-field">*</span></label>
              <input  type="text" formControlName="heading" class="form-control">
              <span class="err" *ngIf="form.get('heading').invalid && formSubmit">subject required</span>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div class="form-group">
              <label>Details <span class="required-field">*</span></label>
              <textarea name="" class="form-control" formControlName="details" style="height: 70px" id="" cols="10" rows="5"></textarea>
              <span class="err" *ngIf="form.get('details').invalid && formSubmit">details required</span>
            </div>
          </div>
          <!-- <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Customer Id <span class="required-field">*</span></label>
              <input  type="text" formControlName="customerID" class="form-control">
              <span class="err" *ngIf="form.get('customerID').invalid && formSubmit">customer id required</span>
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Customer Name <span class="required-field">*</span></label>
              <input  type="text" formControlName="customerName" class="form-control">
              <span class="err" *ngIf="form.get('customerName').invalid && formSubmit">customer name required</span>
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Customer Ph No <span class="required-field">*</span></label>
              <input  type="text" formControlName="customerPhNo" class="form-control">
              <span class="err" *ngIf="form.get('customerPhNo').invalid && formSubmit">customer phone required</span>
            </div>
          </div>-->
          <div class="col-md-6 col-lg-6" *ngIf="this.userCred.userType != 'Client'">
            <div class="form-group">
              <label>Problem With Service Type <span class="required-field">*</span></label>
              <select class="form-control" aria-label="Default select example" formControlName="customerType">
                <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
              </select>
              <span class="err" *ngIf="form.get('customerType').invalid && formSubmit">service type required</span>
            </div>
          </div> 

          <!-- <div class="col-md-6 col-lg-6" *ngFor="let list of keyValueList">
            <div class="form-group" >
              <label>{{list.key}}</label>
              <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
              <select class="form-control" *ngIf="list.possibleValue.length != 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">{{possibleValue}}</option>
              </select>
            </div>
          </div> -->

          
          <!-- <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Assign To</label>
              <select class="form-control" formControlName="assignedToUserName">
                <option value="" disabled selected hidden>---Select User---</option>
                <option *ngFor="let x of usersWithoutCustomers" [value]="x.userName">{{x.userName}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <label>Tag UserID</label>
              <ng-multiselect-dropdown
              [placeholder]="'select tag users'" [ngModelOptions]="{standalone: true}"
              [settings]="tagUsersdropdownSettings"
              [data]="tagUsersdropdownList"
              class="form-control"
              style="padding: 0;border: none"
              [(ngModel)]="tagUsersselectedItems"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>
          </div> -->
          <div class="col-lg-12" hidden="true">
            <label class="image-upload-container btn btn-bwm">
                <!-- <span>Select Image</span> -->
                <input #imageInput
                      type="file" id="add-image-btn"
                      accept="image/*" hidden="true"
                      (change)="onChange($event)">
            </label>
        </div>

        <div class="col-lg-12 media-content">
            <div class="mr-2 image-btn" (click)="addImageBtn()">
              <span>+ Add Image</span>
            </div>
            <br>
            <div class="add-block-image">
              <div class="media-area" *ngFor="let image of images;let index = index" class="mr-2">
                
                <img src="{{image}}" width="150px" height="120px" alt="">
                <div class="image-list-options">
                  <button (click)="viewImg(image)">view</button>
                  <button (click)="removeImg(index)">remove</button>
                </div>
              </div>
            </div>
            
        </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="addcontroller()" class="btn btn-primary">Create Ticket</button>
      </div>
    </div>
  </div>
</div>



<button id="viewImgModel" data-toggle="modal" data-target="#viewModel" hidden="true"></button>
<div class="modal fade" id="viewModel" tabindex="-1" aria-labelledby="viewModelLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" id="modal-msg">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Image
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        
        <img src="{{imgView}}" height="450px" width="100%" alt="">

        <div class="modal-footer">
          <button type="button" id="closeModalButton7" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>